import { ID_VETERINARIO_OFICIAL } from "@/constants/ID_VETERINARIO_OFICIAL";
import { IFormulario } from "@/interfaces/IFormulario";
import { api } from "@/services/api";
import { formularioAction } from "@/store/actions/formulario";
import { getFormularioSynced } from "@/store/reducers/formulario";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { useEstabelecimento } from "./useEstabelecimento";
import { useUsuarioLogado } from "./useUsuarioLogado";

export const useFormulario = () => {
  const { user } = useAuth();
  const listaFormularios = useSelector(getFormularioSynced);
  const appDispatch = useDispatch();
  const { sync } = formularioAction;
  const { listaEstabelecimentos } = useEstabelecimento();
  const { usuarioLogado } = useUsuarioLogado();

  const sincronizarFormularios = (formularios: IFormulario[]) => {
    appDispatch(sync(formularios));
  };

  const getFormulariosApi = async () => {
    const { data } = await api.get<IFormulario[]>(`/formularios/todos`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  const getFormulariosForPerfil = (estabelecimentoId: number) => {
    if (usuarioLogado.perfil.id === 1) {
      return listaFormularios.filter(
        (form) => form.tipoFormulario === "AUDITORIA"
      );
    }

    const estabelecimento = listaEstabelecimentos.find(
      (e) => e.id === estabelecimentoId
    );

    const pessoaInspecao = estabelecimento?.pessoasInspecao.find(
      (pi) => pi.id === usuarioLogado.pessoaId
    );

    if (!pessoaInspecao) {
      return [];
    }

    if (pessoaInspecao.funcao.id === ID_VETERINARIO_OFICIAL) {
      return listaFormularios.filter(
        (form) => form.tipoFormulario === "MONITORIA"
      );
    }

    if (pessoaInspecao.inspetor) {
      return listaFormularios.filter(
        (form) => form.tipoFormulario === "INSPETOR"
      );
    }

    return [];
  };

  return {
    getFormulariosApi,
    sincronizarFormularios,
    listaFormularios,
    getFormulariosForPerfil,
  };
};
